const LEGACY_ISCC_CID_CODES = {
  1: ['CID 1', 'ISCC-CORSIA-FRM-001'],
  2: ['CID 2', 'ISCC-CORSIA-PLUS-FRM-001'],
};

export const getSalesPackCidCode = (isSustainability, cidNumber) => {
  if (!isSustainability) return `CID ${cidNumber}`;
  return cidNumber === 1 ? 'CBQA-ISCC-FRM-001' : 'CBQA-ISCC-FRM-002';
};

// Existing projects can carry the pre-UAT code. Keep those uploads readable while
// every new surface consistently presents the current CBQA ISCC document code.
export const getSalesPackCidCodes = (isSustainability, cidNumber) => {
  const current = getSalesPackCidCode(isSustainability, cidNumber);
  return isSustainability
    ? [current, ...LEGACY_ISCC_CID_CODES[cidNumber]]
    : [current];
};
